import React, { useState, useRef } from 'react';
import { Modal } from 'antd';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { ThemeButton } from '../components';
import { upload_icon } from '../../assets/icons/icons';

const ImageUploader = ({
  image,
  setImage,
  setFormData,
  enableCrop = false,
  aspectRatio = null,
}) => {
  const [cropModalVisible, setCropModalVisible] = useState(false);
  const [selectedImageFile, setSelectedImageFile] = useState(null);
  const [imageSrc, setImageSrc] = useState(null);
  const cropperRef = useRef(null);
  const fileInputRef = useRef(null);

  const handleImage = e => {
    const selectedImage = e.target.files[0];
    if (selectedImage) {
      if (enableCrop) {
        // Show crop modal
        setSelectedImageFile(selectedImage);
        setImageSrc(URL.createObjectURL(selectedImage));
        setCropModalVisible(true);
      } else {
        // Direct upload without cropping
        setFormData(selectedImage);
        setImage(URL.createObjectURL(selectedImage));
      }
    }
  };

  const getCroppedImage = () => {
    const cropper = cropperRef.current?.cropper;
    if (cropper) {
      cropper.getCroppedCanvas().toBlob(blob => {
        if (blob) {
          // Create a File object from the blob
          const file = new File([blob], selectedImageFile.name, {
            type: blob.type,
          });
          setFormData(file);
          setImage(URL.createObjectURL(blob));
          setCropModalVisible(false);
          setImageSrc(null);
          setSelectedImageFile(null);
        }
      });
    }
  };

  const handleCancelCrop = () => {
    setCropModalVisible(false);
    setImageSrc(null);
    setSelectedImageFile(null);
    // Reset file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }
  };

  const handleBrowseClick = e => {
    e.preventDefault();
    e.stopPropagation();
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <div>
      <label htmlFor="uploader">
        <div
          className="w-full rounded-md shadow-md flex items-center justify-center mb-2 cursor-pointer overflow-hidden"
          style={{
            aspectRatio: enableCrop
              ? aspectRatio
                ? `${aspectRatio}/1`
                : '1/1'
              : '1/1',
            minHeight: '200px',
          }}
        >
          {image ? (
            <img
              src={image}
              alt="image"
              className="w-full h-full object-cover"
            />
          ) : (
            <div className="flex items-center flex-col">
              <div className="flex justify-center mb-1">
                <img src={upload_icon} alt="" width={40} />
              </div>
              <p className="">Drag and drop your file</p>
              <p className="">OR</p>
              <div className="flex justify-center mt-1">
                <ThemeButton
                  content={'Browse File'}
                  onClick={handleBrowseClick}
                />
              </div>
            </div>
          )}
        </div>
        <input
          ref={fileInputRef}
          type="file"
          onChange={e => handleImage(e)}
          id={'uploader'}
          className="hidden"
          accept=".png, .jpg, .jpeg"
        />
      </label>

      {enableCrop && (
        <Modal
          title="Crop Image"
          open={cropModalVisible}
          onCancel={handleCancelCrop}
          width={600}
          footer={
            <div className="flex justify-end gap-3">
              <ThemeButton
                onClick={handleCancelCrop}
                content="Cancel"
                bgColor="!bg-gray-200"
                className="!text-gray-700 hover:!bg-gray-300"
              />
              <ThemeButton onClick={getCroppedImage} content="Apply Crop" />
            </div>
          }
        >
          <div style={{ width: '100%', height: '400px' }}>
            {imageSrc && (
              <Cropper
                ref={cropperRef}
                src={imageSrc}
                style={{ height: '100%', width: '100%' }}
                aspectRatio={aspectRatio !== null ? aspectRatio : undefined}
                guides={true}
                viewMode={1}
                minCropBoxHeight={10}
                minCropBoxWidth={10}
                background={false}
                responsive={true}
                autoCropArea={0.8}
                checkOrientation={false}
                ready={() => {
                  // Ensure crop box is initialized with correct aspect ratio
                  if (aspectRatio !== null && cropperRef.current?.cropper) {
                    cropperRef.current.cropper.setAspectRatio(aspectRatio);
                  }
                }}
              />
            )}
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ImageUploader;
